import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TenantScopeService } from '@core/services/tenant-scope.service';

import { IconComponent } from '@shared/components/icon/icon.component';

/**
 * Storefront footer. Marketplace scope shows the Brijj Finds links; tenant
 * scope swaps to the tenant's identity with a "Powered by brijjworks" credit.
 */
@Component({
  selector: 'app-marketplace-footer',
  standalone: true,
  imports: [RouterLink, IconComponent],
  templateUrl: './marketplace-footer.component.html',
  styleUrl: './marketplace-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketplaceFooterComponent {
  protected readonly tenantScope = inject(TenantScopeService);
}
